import { styled as k, FormControl as w, useTheme as S, useMediaQuery as b, InputLabel as v, Card as F, Stack as o } from "@mui/material";
import e from "react";
import { T as i } from "./chunk.35QuuDPq.js";
import { B as u } from "./chunk.hFvqNSIf.js";
const W = k(w, {
  name: "SelectionSummaryField",
  slot: "root"
})({}), M = ({
  id: m,
  disabled: t,
  required: d,
  label: f,
  subtitle: x,
  dataPoint: l,
  actionOne: r,
  actionTwo: a,
  ...g
}) => {
  const { palette: c, breakpoints: y } = S(), s = b(y.down("sm")), p = Array.isArray(l), n = !p && !s, E = n ? "center" : "flex-start";
  return /* @__PURE__ */ e.createElement(
    W,
    {
      fullWidth: !0,
      disabled: t,
      "aria-disabled": t,
      "data-testid": g["data-testid"]
    },
    /* @__PURE__ */ e.createElement(
      v,
      {
        id: `${m}-label`,
        disabled: t,
        "aria-disabled": t,
        required: d
      },
      f
    ),
    /* @__PURE__ */ e.createElement(F, { id: `${m}-card`, variant: "outlined" }, /* @__PURE__ */ e.createElement(
      o,
      {
        direction: n ? "row" : "column",
        marginLeft: 2,
        marginRight: 1,
        marginY: 1,
        alignItems: s ? "flex-end" : E,
        gap: 1,
        flexWrap: "wrap",
        justifyContent: "flex-end",
        minHeight: "40px"
      },
      /* @__PURE__ */ e.createElement(
        o,
        {
          direction: n ? "row" : "column",
          rowGap: 2,
          columnGap: 4,
          marginY: 1,
          marginRight: "auto",
          flexWrap: "wrap"
        },
        /* @__PURE__ */ e.createElement(i, { variant: "subtitle200", fontWeight: "semiBold" }, x),
        /* @__PURE__ */ e.createElement(
          o,
          {
            direction: n ? "row" : "column",
            columnGap: 4,
            flexWrap: "wrap"
          },
          p ? l.map((C, h) => /* @__PURE__ */ e.createElement(
            i,
            {
              key: `dataPoint-${h}`,
              variant: "body100",
              color: c.grey[600]
            },
            C
          )) : /* @__PURE__ */ e.createElement(i, { variant: "body100", color: c.grey[600] }, l)
        )
      ),
      (r || a) && /* @__PURE__ */ e.createElement(
        o,
        {
          direction: "row",
          justifyContent: "flex-end",
          alignSelf: "flex-end",
          flexWrap: "wrap"
        },
        r && /* @__PURE__ */ e.createElement(
          u,
          {
            buttonText: r.text,
            onClick: r.onClick,
            variant: "text",
            disabled: t
          }
        ),
        a && /* @__PURE__ */ e.createElement(
          u,
          {
            buttonText: a.text,
            onClick: a.onClick,
            variant: "text",
            disabled: t,
            "aria-disabled": t
          }
        )
      )
    ))
  );
};
export {
  M as S
};
